export default {
    primary : '#158229',
    primaryLight : '#199c19', 
    primaryDark: '#00420c',
    primaryContrast : '#004D3D',

    secondaryContrast : '#992900',

    danger : '#cf3419',
    alert : '#F5BB00',
    success : '#52cf25',
    link: '#0044CC',

    dangerLight : '#ffb7a3',


    dark : '#272838',
    grey : '#D3D3D3',
    light : '#F2F2F2',

    white : '#FFFFFF',

    tableEvenRowEvenCol : '#BFBFBF',
    tableEvenRowOddCol : '#D3D3D3',
    tableOddRowEvenCol : '#E0E0E0',
    tableOddRowOddCol : '#F2F2F2',

    inputBorder: '#086788',
};